<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="form-section">
        <i class="ft-repeat"></i> {{ 'financialTransactionDetails.title' | translate }}</h4>
    </div>
    <div class="card-body">
      <div class="px-3">

        <!-- FinancialTransactionId -->
        <div class="card-field">
          <div
            class="card-field-label">{{ 'financialTransactionDetails.financialTransactionIdFieldLabel' | translate }}
          </div>
          <div class="card-field-content">{{ currentObject.FinancialTransactionId }}</div>
        </div>

        <!-- CreatedAt -->
        <div class="card-field">
          <div class="card-field-label">{{ 'financialTransactionDetails.createdAtFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.CreatedAt | date:'d-M-y HH:mm:ss' }}</div>
        </div>

        <!-- Company.Name -->
        <div class="card-field">
          <div class="card-field-label">{{ 'financialTransactionDetails.companyNameFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.Company.Name }}</div>
        </div>

        <!-- User.FullName -->
        <div class="card-field">
          <div class="card-field-label">{{ 'financialTransactionDetails.userFullNameFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.User.FullName }}</div>
        </div>

        <!-- Module.Name & ModuleEntryId -->
        <div class="card-field">
          <div class="card-field-label">{{ 'financialTransactionDetails.moduleNameFieldLabel' | translate }}</div>
          <div class="card-field-content" *ngIf="currentObject.Module; else noModule">
            {{ currentObject.Module.Name }}{{ currentObject.ModuleLinkedObjectId ? ' #' + currentObject.ModuleLinkedObjectId : '' }}
          </div>
          <ng-template #noModule>
            <div class="card-field-content">-</div>
          </ng-template>
        </div>

        <!-- Amount -->
        <div class="card-field">
          <div class="card-field-label">{{ 'financialTransactionDetails.amountFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.AmountCurrency }}</div>
        </div>

        <!-- CreditAmountAfter -->
        <div class="card-field">
          <div class="card-field-label">{{ 'financialTransactionDetails.creditAmountAfterFieldLabel' | translate }}
          </div>
          <div class="card-field-content">{{ currentObject.CreditAmountAfterCurrency }}</div>
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary btn-raised mr-1 float-right" (click)="closeModal()">
            <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
